// @flow @format

type A = {type: string};
type Reducer<S> = (state: S, action: A) => S;

export function handleActions<S>(
	handlers: Object,
	initialState: S,
): Reducer<S> {
	return function reducer(state: S = initialState, action: A): S {
		if (handlers.hasOwnProperty(action.type)) {
			return handlers[action.type](state, action);
		}
		return state;
	};
}



// WEBPACK FOOTER //
// ./src/lib/redux-actions/index.js